import React, { useMemo, useCallback } from 'react';
import cn from 'classnames';
import BriefFamilyPerson from './BriefFamilyPerson';
import BriefFamilyPet from './BriefFamilyPet';

const OPTIONS = ['0', '1', '2', '3', '4+'];
const fill = n => [...new Array(n)].map((_, i) => i);

const BriefFamilySelector = ({
  title,
  value,
  invalid,
  type = 'adult',
  className,
  onChange,
}) => {
  const rows = useMemo(() => fill(Object.keys(value).length), [value]);

  const handleAmountChange = useCallback(
    (event, amount) => {
      event.preventDefault();
      const newMembers = fill(amount).reduce(
        (acct, key) => ({
          ...acct,
          [key]: value[key] || {},
        }),
        {},
      );
      onChange(newMembers);
    },
    [value],
  );

  const handleMemberChange = (index, member) => {
    onChange({
      ...value,
      [index]: member,
    });
  };

  return (
    <div className={cn('member-selection_col', className)}>
      <div className="member-selection_title">{title}</div>
      <div className="member-selection_row">
        {OPTIONS.map((option, index) => (
          <label
            key={option}
            className="member-selection_checkbox"
            onClick={event => handleAmountChange(event, index)}
          >
            <input
              className="member-selection_checkbox-input"
              readOnly
              checked={index === rows.length}
              value={option}
              name={`option_${title}`}
              type="radio"
            />
            <span className="member-selection_checkbox-label -mint -highlight-mint">{option}</span>
          </label>
        ))}
      </div>
      <div className="rows container">
        {rows.map(
          (row, index) =>
            type === 'pet' ? (
              <BriefFamilyPet
                key={row}
                value={value[index]}
                invalid={invalid}
                onChange={handleMemberChange.bind(null, row)}
              />
            ) : (
              <BriefFamilyPerson
                key={row}
                value={value[index]}
                invalid={invalid}
                maleLabel={type === 'adult' ? 'Male' : 'Boy'}
                femaleLabel={type === 'adult' ? 'Female' : 'Girl'}
                onChange={handleMemberChange.bind(null, row)}
              />
            ),
        )}
      </div>
    </div>
  );
};

export default BriefFamilySelector;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefFamily/BriefFamilySelector.js